export const SET_EVENT_ACTIONS = "SET_EVENT_ACTIONS";
export const UPDATE_ACTIONS = "UPDATE_ACTIONS";